import { render, staticRenderFns } from "./SupplierManageList.vue?vue&type=template&id=b56c274a&"
import script from "./SupplierManageList.vue?vue&type=script&lang=js&"
export * from "./SupplierManageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports